import {Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent} from '@mui/material';
import React, {useContext, useEffect, useState} from 'react';
import ZeiterfassungDashboardContext from '../../../../../Contexts/ZeiterfassungDashboardContext/ZeiterfassungDashboardContext';

export default function FilterDepartment() {
  const {arbeitszeiten_alle_MA, filter, dispatchFilter} = useContext(ZeiterfassungDashboardContext);

  // Get departments list from context
  const departments = arbeitszeiten_alle_MA?.departments || [];

  // Handler for department selection change
  const handleChange = (event: SelectChangeEvent) => {
    const newDepartment = event.target.value;
    dispatchFilter({
      type: 'SET_DEPARTMENT',
      payload: newDepartment,
    });
  };

  return (
    <FormControl sx={{m: 1, minWidth: 250}}>
      <InputLabel id='department-select-label'>Firma/Abteilung</InputLabel>
      <Select
        labelId='department-select-label'
        id='department-select'
        value={filter.department}
        MenuProps={{
          autoFocus: false,
        }}
        onChange={handleChange}
        label='Firma/Abteilung'>
        <MenuItem value=''>
          <em>Alle</em>
        </MenuItem>
        {departments.map((dep: string) => (
          <MenuItem key={dep} value={dep}>
            {dep}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
